import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { HeartPulse } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data.user);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { state: { user: res.data.user } });
      } catch {
        navigate("/");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#FBFBF7]">
      <div className="relative">
        <div className="absolute inset-0 rounded-full bg-amber-200/60 blur-2xl animate-pulse" />
        <div className="relative w-16 h-16 rounded-2xl bg-[#1E5AA8] flex items-center justify-center shadow-lg">
          <HeartPulse className="w-8 h-8 text-white" />
        </div>
      </div>
      <p className="mt-6 text-slate-600 font-medium">Signing you in securely…</p>
    </div>
  );
}
